import mirror from 'key-mirror'

const actionTypes = mirror({
    SET_CONVERSATIONS_CONNECTION_STATUS: null,

    INIT_CONVERSATIONS_REQUEST: null,
    INIT_CONVERSATIONS_SUCCESS: null,
    INIT_CONVERSATIONS_FAILURE: null,

    SET_LAST_SELECTED_CONVERSATION: null,
    SET_LAST_CONVERSATION_MESSAGE: null,

    ADD_UNSENT_CONVERSATION_MESSAGE: null,
    REMOVE_UNSENT_CONVERSATION_MESSAGE: null,

    SET_CONVERSATION_USER_ONLINE: null,
    LOAD_CONVERSATION_USERS_REQUEST: null,
    LOAD_CONVERSATION_USERS_SUCCESS: null,
    LOAD_CONVERSATION_USERS_FAILURE: null,

    DESTROY_CONVERSATIONS_REQUEST: null,
    DESTROY_CONVERSATIONS_SUCCESS: null,
    DESTROY_CONVERSATIONS_FAILURE: null,

    UPDATE_LIVE_CONVERSATIONS: null,
})

export default actionTypes